import { SnackThumbnailField } from "@/components/features/snack/_shared/ui/thumbnail-field";

import { Button } from "@/components/ui/button/button";
import { RoundedFullButton } from "@/components/ui/button/rounded-full-button";
import { Dialog, DialogClose, DialogContent } from "@/components/ui/dialog/dialog";
import { Image } from "@/components/ui/image/image";

import type { SnackBlocksFormModelMethodsType } from "../../../../../model/usecase/use-create-snack-layout-settings-form-model/methods";

type Props = {
	logoImageMethods: SnackBlocksFormModelMethodsType["logoImageMethods"];
};

export const IslandLayoutSettingsLogoImage = ({ logoImageMethods }: Props) => {
	const {
		activateSelectLogoImageModal,
		onOpenChange,
		onSetLogoImage,
		onDeleteLogoImage,
		deactivateSelectLogoImageModal,
		imageRepository,
		imageUploader,
		isShowSelectLogoImageModal,
		logoImage,
	} = logoImageMethods;

	return (
		<div className="flex justify-center">
			<div>
				{logoImage?.value ? (
					<div className="relative mx-auto w-1/5">
						<Image src={logoImage.value} alt="logo" className="" />
						<RoundedFullButton className="absolute -right-2 top-0" onClick={onDeleteLogoImage} />
					</div>
				) : (
					<Button type="button" size="sm" variant="outline" onClick={activateSelectLogoImageModal}>
						ロゴ画像を選択
					</Button>
				)}
			</div>

			<Dialog open={isShowSelectLogoImageModal} onOpenChange={onOpenChange}>
				<DialogClose onClick={deactivateSelectLogoImageModal} />

				<DialogContent>
					<SnackThumbnailField
						thumbnail={logoImage}
						onSetThumbnail={onSetLogoImage}
						imageRepository={imageRepository}
						imageUploader={imageUploader}
					/>
				</DialogContent>
			</Dialog>
		</div>
	);
};

IslandLayoutSettingsLogoImage.displayName = "IslandLayoutSettingsLogoImage";
